import { useLocation } from "react-router-dom";
/**
 * Pre-checkout / checkout / payment funnel prefixes. Everything under these
 * paths renders the simplified header (logo + account + cart + notifications +
 * language) without the navigation lists, main links, or the sell-car CTA.
 */
export var CHECKOUT_FUNNEL_PREFIXES = ["/pre-checkout", "/checkout", "/payedsuccess", "/payedfailed", "/paylink", "/remaining-payment", "/finance-remaining-payment", "/finance-apply-free", "/finance-apply-arib", "/finance-apply-tabby", "/finance-apply-tamara", "/finance-apply-amwal", "/finance/rejected", "/site/split-payment", "/site/warranty-payment", "/site/dhamen", "/site/cart/checkout", "/site/cart/oil-payment-status"];

/**
 * Signed-in / account area. These render the lite header too: the account and
 * checkout surfaces are not places to browse the catalogue from.
 *
 * `shouldAuth: true` in `src/routes/routes.ts` is the app's source of truth for
 * "requires login", and every route carrying it is covered here or by
 * CHECKOUT_FUNNEL_PREFIXES above. The bare `/user` and `/site` prefixes also
 * pull in the auth screens themselves (`/user/signup`, `/user/login`) and the
 * public-but-account-shaped pages such as `/site/recently-viewed`.
 *
 * Prefix-matched, so parameterised children (`/tracking-report/:id/*`,
 * `/user/account/my-info/edit-name`, …) are covered without listing each one.
 */
export var USER_AREA_PREFIXES = ["/user", "/site", "/tracking-landing", "/tracking-service-details", "/tracking-finance-details", "/tracking-checkout-details", "/tracking-report", "/tracking-return-wizard", "/referral", "/referral-list", "/orders", "/report"];

/** True when `path` equals one of `prefixes` or sits under it. */
export var matchesPrefix = function matchesPrefix(path, prefixes) {
  return prefixes.some(function (prefix) {
    return path === prefix || path.startsWith(prefix + "/");
  });
};

/** Strips the `/en` language prefix so both locales resolve the same variant. */
export var normalizeNavPath = function normalizeNavPath(pathname) {
  var withoutLang = pathname.replace(/^\/en(?=\/|$)/, "");
  var trimmed = withoutLang.replace(/\/+$/, "");
  return trimmed === "" ? "/" : trimmed;
};
export var getDesktopNavVariant = function getDesktopNavVariant(pathname) {
  var path = normalizeNavPath(pathname);
  var isLite = matchesPrefix(path, CHECKOUT_FUNNEL_PREFIXES) || matchesPrefix(path, USER_AREA_PREFIXES);
  return isLite ? "lite" : "full";
};
var useDesktopNavVariant = function useDesktopNavVariant(override) {
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  return override !== null && override !== void 0 ? override : getDesktopNavVariant(pathname);
};
export default useDesktopNavVariant;